// Objet qui contient les propriétés pour chaque police
export const typesPolices = {
	Arial: {
		facteur_taille_police: 0.6,
		epaisseur_police: "normal",
		coef_marge: 0.28,
		coef_marge_windows: 0.25,
		distance_soulignage: 0.3,
		ligatures: [1, 0],
		bouton_ligatures_display: "none",
	},
	"AA Cursive": {
		facteur_taille_police: 0.75,
		epaisseur_police: "normal",
		coef_marge: 0.35,
		coef_marge_windows: 0.3125,
		distance_soulignage: 0.3,
		ligatures: [0, 1],
		bouton_ligatures_display: null,
	},
	"Open Dyslexic": {
		facteur_taille_police: 0.45,
		epaisseur_police: "normal",
		coef_marge: 0.35,
		coef_marge_windows: 0.35,
		distance_soulignage: 0.5,
		ligatures: [1, 0],
		bouton_ligatures_display: "none",
	},
	"Belle Allure CE": {
		facteur_taille_police: 0.6,
		epaisseur_police: "bold",
		coef_marge: 0.375,
		coef_marge_windows: 0.334821429,
		distance_soulignage: 0.38,
		ligatures: [1, 0],
		bouton_ligatures_display: "none",
	},
	"Belle Allure CM": {
		facteur_taille_police: 0.6,
		epaisseur_police: "bold",
		coef_marge: 0.375,
		coef_marge_windows: 0.334821429,
		distance_soulignage: 0.38,
		ligatures: [1, 0],
		bouton_ligatures_display: "none",
	},
	"Belle Allure GS": {
		facteur_taille_police: 0.6,
		epaisseur_police: "bold",
		coef_marge: 0.375,
		coef_marge_windows: 0.334821429,
		distance_soulignage: 0.38,
		ligatures: [1, 0],
		bouton_ligatures_display: "none",
	},
	"Belle Allure script": {
		facteur_taille_police: 0.6,
		epaisseur_police: "bold",
		coef_marge: 0.375,
		coef_marge_windows: 0.334821429,
		distance_soulignage: 0.38,
		ligatures: [1, 0],
		bouton_ligatures_display: "none",
	},
	Acceseditionscursive: {
		facteur_taille_police: 0.674,
		epaisseur_police: "normal",
		coef_marge: 0.272,
		coef_marge_windows: 0.242857143,
		distance_soulignage: 0.379,
		ligatures: [1, 0],
		bouton_ligatures_display: "none",
	},
	Luciole: {
		facteur_taille_police: 0.65,
		epaisseur_police: "normal",
		coef_marge: 0.29,
		coef_marge_windows: 0.258928572,
		distance_soulignage: 0.379,
		ligatures: [1, 0],
		bouton_ligatures_display: "none",
	},
	Romain: {
		facteur_taille_police: 0.8,
		epaisseur_police: "bold",
		coef_marge: 0.3,
		coef_marge_windows: 0.334821429,
		distance_soulignage: 0.38,
		ligatures: [1, 0],
		bouton_ligatures_display: "none",
	},
};
